import { Button, Modal } from 'antd';
import ExclamationIcon from 'assets/icons/check-circle-fill-big.svg';

import { useDispatch } from 'react-redux';

import { setVisibleCU02902 } from 'presentation/redux/features/CU/CU02902Slice';
import { useAppSelector } from 'presentation/redux/hooks';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useNavigate } from 'react-router-dom';

type props = {
    description: string | string[];
    title: string;
};

export const ModalRegisterProperty = ({ description, title }: props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const visibleModalCU02902 = useAppSelector((state) => state.CU02902Slice.isVisibleCU02902);

    const submit = async () => {
        navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.DASHBOARD}`);
        dispatch(setVisibleCU02902());
    };

    const descriptionContent = (content: string | string[]) => {
        if (typeof content === 'string') return content;
        return (
            <div className="content-container">
                {content.map((item, index) => (
                    <div className="text-description-modal" key={index}>
                        {item}
                    </div>
                ))}
            </div>
        );
    };

    return (
        <Modal
            width={340}
            open={visibleModalCU02902}
            footer={null}
            centered
            className="modal-register-property"
        >
            <section style={{ paddingTop: 12, paddingBottom: 12 }}>
                <div style={{ width: '100%' }} className="center-inside">
                    <img src={ExclamationIcon} alt="" />
                </div>
                <div className="text-title-modal" style={{ marginBottom: 24, marginTop: 28 }}>
                    {title}
                </div>

                <>{descriptionContent(description)}</>

                <Button
                    className="text-button-ok"
                    type="primary"
                    style={{ width: '100%', height: 48 }}
                    onClick={submit}
                >
                    ダッシュボードに戻る
                </Button>
            </section>
        </Modal>
    );
};
